/* eslint-disable no-useless-concat */
import * as d3 from 'd3'
import {numberWithCommas} from '../_common/utils'

export default function drawChart(chartDivId,height, width, data,linkChartData,isZoomNeeded){
  const pack = data => d3.pack()
    .size([width, height])
    .padding(3)
    (d3.hierarchy(data)
      .sum(d => d.value)
      .sort((a, b) => b.value - a.value))
  const color = d3.scaleLinear()
    .domain([0, 5])
    .range(['hsl(201,100%,69%)', 'hsl(217,26%,17%)'])
    .interpolate(d3.interpolateHcl)

  const root = pack(data)
  let focus = root
  let view

  const svg = d3.select(chartDivId)
    .append('svg')
    .attr('viewBox', `-${width / 2} -${height/2} ${width+100} ${height+100}`)
    .style('display', 'block')
    .style('margin', '0 -14px')
    .style('background', color(0))
    .style('cursor', 'pointer')
  if(isZoomNeeded)
    svg.on('click', () => zoom(root))

  const Tooltip = d3.select(chartDivId)
    .append('div')
    .style('opacity', 0)
    .attr('class', 'bubleTip')
    .style('background-color', '#373D3F')
    .style('border', 'solid')
    .style('border-width', '1px')
    .style('border-radius', '5px')
    .style('border-color', '#373D3F')
    .style('padding', '5px')
    .style('position','absolute')

  const tootipMouseMove=(d)=>{
    if(d.data.companyId !==null || d.data.industryId !==null){
      //console.log(d)
      let text=''
      let sector=''
      const divSector=document.getElementById('sector-detail')
      if(divSector)
        sector=divSector.innerHTML
      if(sector===null){
        sector=''
      }
      if(d.data.companyId !=null){
        /* eslint-disable-line no-useless-concat */
        text ='<div class="tipLogo">'+(d.data.logoPath?'<img style="width:100%" src="'+d.data.logoPath+'" />':'' )+ '</div><br/>' + '<b>' + d.data.name+ '</b>' + ': $' + numberWithCommas(d.value) + '<br/><b>Ticker: </b>' + d.data.ticker+ (sector?'<br/> ' + sector:'')+('<br/>'+(d.data.exchangeName?d.data.exchangeName:''))
      }
      if(d.data.industryId !==null && d.data.companyId===null){
        text =''+d.data.name+''
      }
      Tooltip.html(text)
        .style('left', (d3.event.pageX+20) + 'px')
        .style('top', (d3.event.pageY - 80) + 'px')
    }else {
      if(d.data.sectorId !=null || d.data.industryId !=null){
        Tooltip.html('<div>'+''+d.data.name+'</div>')
          .style('left', (d3.event.pageX+20) + 'px')
          .style('top', (d3.event.pageY - 80) + 'px')
      }
    }
  }
  const node = svg.append('g')
    .selectAll('circle')
    .data(root.descendants().slice(1))
    .join('circle')
    .attr('title',d=>null !==d.name?d.name:'')
    .attr('fill', d => d.children ? color(d.depth) : 'white')
    .attr('pointer-events', d => !d.children && isZoomNeeded ? 'none' : null)
    .attr('class',d => d.children ? 'industry-detail' :'company-detail')
    .on('mouseover', function(d) {
      //if(d.data.companyId !==null){
      Tooltip
        .style('opacity', 1)
      //}
      d3.select(this).attr('stroke', '#000')
    })
    .on('mousemove',function(d){
      tootipMouseMove(d)
    })
    .on('mouseout', function() {
      Tooltip
        .style('opacity', 0)
      d3.select(this).attr('stroke', null) })
    .on('click', d => isZoomNeeded?focus !== d && (zoom(d), d3.event.stopPropagation()):null)
  //!isZoomNeeded?showCompanyDetail(d)

  const label = svg.append('g')
    .style('font', isZoomNeeded?'18px calibri':'20px calibri')
    .attr('text-anchor', 'middle')
    .attr('stroke', '#000')
    .selectAll('text')
    .data(root.descendants())
    .join('text')
    .style('fill-opacity', d => d.parent === root ? 1 : 0)
    .style('display', d => d.parent === root && d.r>50 ? 'inline' : 'none')
    .attr('label',d=>d.data.name)
    .text(d =>d.data.companyId !=null ? d.data.ticker : (d.r>45? (d.data.name.length>10? d.data.name.substring(0,7)+'...':d.data.name):'')
     
    ).on('mouseover', function(d) {
      if(d.data.companyId !=null){
        Tooltip
          .style('opacity', 1)
      }
    })
    .on('mousemove',function(d){
      tootipMouseMove(d)
    })
    .on('mouseout', function() {
      Tooltip
        .style('opacity', 0)
    })

  const zoomLevel=4.5
  zoomTo([root.x, root.y, root.r * zoomLevel])

  function zoomTo(v) {
    const k = width / v[2]
    view = v
    label.attr('transform', d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`)
    node.attr('transform', d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`)
    node.attr('r', d => d.r * k)
    label.text(d=> k>20 ? (d.data.companyId!=null ? d.data.ticker:'') : (d.data.industryId!=null && d.data.companyId !=null? d.data.ticker:(null != d.data.name && d.data.name.length>10? d.data.name.substring(0,7)+'...':d.data.name)))
  }

  function zoom(d) {
    focus = d
    const transition = svg.transition()
      .duration(d3.event.altKey ? 7500 : 750)
      .tween('zoom', d => {
        const i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * zoomLevel])
        return t => zoomTo(i(t))
      })

    label
      .filter(function(d) { return d.parent === focus || this.style.display === 'inline' })
      .transition(transition)
      .style('fill-opacity', d => d.parent === focus ? 1 : 0)
      .on('start', function(d) { if (d.parent === focus) this.style.display = 'inline' })
      .on('end', function(d) { if (d.parent !== focus) this.style.display = 'none' })

    console.log(d)
    if(null != d.data && d.data.industryId !=null){
      linkChartData(d)
    }
    else
    {
      linkChartData(null)
    }
  }
}
